(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const toggleItems = document.querySelectorAll(".category-toggle-item");
  const contentItems = document.querySelectorAll(".category-content-item");

  toggleItems.forEach((toggle, index) => {
    toggle.addEventListener("click", function () {
      toggleItems.forEach((item) => item.classList.remove("active"));
      contentItems.forEach((item) => item.classList.remove("active"));

      // Toggle the active class with a small delay to ensure transitions work
      setTimeout(function () {
        toggle.classList.add("active");
        contentItems[index].classList.add("active");
      }, 10);
    });
  });

  // Initialize the first category as active
  toggleItems[0].click();
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.scrollButtons = document.querySelector(".scroll-buttons");
      this.selectedProducts = document.querySelector(".selected-products");
      this.selectedProductsList = document.querySelector("#selected-products-list");
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `110px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const hasScrolled = scrollTop !== this.currentScrollTop;

      if (hasScrolled) {
        this.closeMenuDisclosure();
        this.closeSearchModal();
        this.preventHide = false;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      if (this.scrollButtons) {
        this.scrollButtons.classList.remove('move');
      }
      if (this.selectedProducts) {
        this.selectedProducts.classList.remove('move');
        this.selectedProductsList.classList.remove('move');
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.scrollButtons) {
        this.scrollButtons.classList.add('move');
      }
      if (this.selectedProducts) {
        this.selectedProducts.classList.add('move');
         this.selectedProductsList.classList.add('move');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-simple-slideshow]';

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const updateAccessibility = (slides, activeIndex) => {
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) {
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('tabindex', '-1');
        }
      });
    };

    const initSlider = (container) => {
      if (!container || container.dataset.simpleSlideshowInitialized === 'true') return;

      const track = container.querySelector('[data-slideshow-track]');
      const slides = track ? Array.from(track.querySelectorAll('[data-slide-index]')) : [];
      const prev = container.querySelector('[data-slide-prev]');
      const next = container.querySelector('[data-slide-next]');

      if (!track || !slides.length) {
        container.dataset.simpleSlideshowInitialized = 'true';
        return;
      }

      let currentIndex = 0;
      let isProgrammatic = false;

      const updateButtons = () => {
        if (prev) prev.disabled = currentIndex === 0;
        if (next) next.disabled = currentIndex === slides.length - 1;
      };

      const updateState = () => {
        updateButtons();
        updateAccessibility(slides, currentIndex);
      };

      const scrollToIndex = (index, behavior = 'smooth') => {
        const targetIndex = clamp(index, 0, slides.length - 1);
        const targetSlide = slides[targetIndex];
        if (!targetSlide) return;

        currentIndex = targetIndex;
        isProgrammatic = true;
        track.scrollTo({
          left: targetSlide.offsetLeft,
          behavior,
        });
        window.clearTimeout(track._simpleScrollTimeout);
        track._simpleScrollTimeout = window.setTimeout(() => {
          isProgrammatic = false;
        }, 300);
        updateState();
      };

      const handleScroll = () => {
        if (isProgrammatic) return;
        const scrollLeft = track.scrollLeft;
        let closestIndex = currentIndex;
        let smallestDelta = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const delta = Math.abs(slide.offsetLeft - scrollLeft);
          if (delta < smallestDelta) {
            smallestDelta = delta;
            closestIndex = index;
          }
        });

        if (closestIndex !== currentIndex) {
          currentIndex = closestIndex;
          updateState();
        }
      };

      prev?.addEventListener('click', () => scrollToIndex(currentIndex - 1));
      next?.addEventListener('click', () => scrollToIndex(currentIndex + 1));

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(track._simpleScrollRaf);
        track._simpleScrollRaf = window.requestAnimationFrame(handleScroll);
      });

      const resizeObserver = new ResizeObserver(() => {
        scrollToIndex(currentIndex, 'auto');
      });
      resizeObserver.observe(track);
      slides.forEach((slide) => resizeObserver.observe(slide));

      container.dataset.simpleSlideshowInitialized = 'true';
      updateState();
      scrollToIndex(0, 'auto');
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll(SELECTOR).forEach(initSlider);
    };

    document.addEventListener('DOMContentLoaded', () => initializeAll());
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
